<template>
  <div class="d-flex ManageWebsites">
    <div class="modal-wrapper d-flex flex-column" :class="currentTab">
      <h1>Winkel toevoegen</h1>

      <BootstrapModal
        v-if="showSetup"
        class="modal"
        :header-class="skeClass"
        :disableButton="true"
        :remove-padding="true"
        :normal-modal="false"
        :remove-title="true"
        :remove-overflow="true"
        :remove-close-icon="true"
        portal-target="bootstrap-modal-header-top"
        portal-target-close="bootstrap-modal-header-close-top"
        @close="close"
      >
        <template #title> Winkel instellen </template>

        <SetupStepsSidebar
          :steps="steps"
          :remove-save-button="true"
          :loading="!loadedWebsite"
          :is-editing="websiteUid"
          @active="active => (currentTab = active)"
          ref="steps"
        >
          <template #icon-website-data>
            <svg
              width="16"
              height="16"
              viewBox="0 0 15 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.5 14C11.0899 14 14 11.0899 14 7.5C14 3.91015 11.0899 1 7.5 1C3.91015 1 1 3.91015 1 7.5C1 11.0899 3.91015 14 7.5 14Z"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M5 5H10"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M5 7.5H10"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M5 10H10"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </template>
          <template #icon-company-details>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 48 48"
            >
              <g
                transform="matrix(3.4285714285714284,0,0,3.4285714285714284,0,0)"
              >
                <g>
                  <polygon
                    points="8.5 13.5 0.5 13.5 0.5 4 4.5 0.5 8.5 4 8.5 13.5"
                    style="
                      fill: none;
                      stroke: currentColor;
                      stroke-linecap: round;
                      stroke-linejoin: round;
                    "
                  ></polygon>
                  <polyline
                    points="8.5 13.5 13.5 13.5 13.5 6.5 8.5 6.5"
                    style="
                      fill: none;
                      stroke: currentColor;
                      stroke-linecap: round;
                      stroke-linejoin: round;
                    "
                  ></polyline>
                  <line
                    x1="4.5"
                    y1="13.5"
                    x2="4.5"
                    y2="11.5"
                    style="
                      fill: none;
                      stroke: currentColor;
                      stroke-linecap: round;
                      stroke-linejoin: round;
                    "
                  ></line>
                  <line
                    x1="3"
                    y1="8.5"
                    x2="6"
                    y2="8.5"
                    style="
                      fill: none;
                      stroke: currentColor;
                      stroke-linecap: round;
                      stroke-linejoin: round;
                    "
                  ></line>
                  <line
                    x1="3"
                    y1="5.5"
                    x2="6"
                    y2="5.5"
                    style="
                      fill: none;
                      stroke: currentColor;
                      stroke-linecap: round;
                      stroke-linejoin: round;
                    "
                  ></line>
                </g>
              </g>
            </svg>
          </template>
          <template #icon-tier_prices>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 14 14"
              height="16"
              width="16"
            >
              <g>
                <g>
                  <line
                    x1="7"
                    y1="10.02"
                    x2="7"
                    y2="11.03"
                    fill="none"
                    stroke="#000000"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></line>
                  <line
                    x1="7"
                    y1="5.01"
                    x2="7"
                    y2="5.95"
                    fill="none"
                    stroke="#000000"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></line>
                </g>
                <path
                  d="M7,13.49c3.5,0,6-1.24,6-4,0-3-1.5-5-4.5-6.5L9.68,1.47a.66.66,0,0,0-.56-1H4.88a.66.66,0,0,0-.56,1L5.5,3C2.5,4.51,1,6.51,1,9.51,1,12.25,3.5,13.49,7,13.49Z"
                  fill="none"
                  stroke="#000000"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M6,9.56A1.24,1.24,0,0,0,7,10,1.12,1.12,0,0,0,8.19,9,1.12,1.12,0,0,0,7,8,1.12,1.12,0,0,1,5.81,7,1.11,1.11,0,0,1,7,6,1.26,1.26,0,0,1,8,6.4"
                  fill="none"
                  stroke="#000000"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </g>
            </svg>
          </template>
          <template #icon-analytics>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 48 48"
            >
              <g
                transform="matrix(3.4285714285714284,0,0,3.4285714285714284,0,0)"
              >
                <g>
                  <rect
                    x="0.5"
                    y="1"
                    width="5"
                    height="5"
                    style="
                      fill: none;
                      stroke: currentColor;
                      stroke-linecap: round;
                      stroke-linejoin: round;
                    "
                  ></rect>
                  <line
                    x1="13.25"
                    y1="13.5"
                    x2="8.25"
                    y2="13.5"
                    style="
                      fill: none;
                      stroke: currentColor;
                      stroke-linecap: round;
                      stroke-linejoin: round;
                    "
                  ></line>
                  <line
                    x1="8.25"
                    y1="8.5"
                    x2="13.25"
                    y2="8.5"
                    style="
                      fill: none;
                      stroke: currentColor;
                      stroke-linecap: round;
                      stroke-linejoin: round;
                    "
                  ></line>
                  <line
                    x1="8.25"
                    y1="11"
                    x2="13.25"
                    y2="11"
                    style="
                      fill: none;
                      stroke: currentColor;
                      stroke-linecap: round;
                      stroke-linejoin: round;
                    "
                  ></line>
                  <polygon
                    points="13.5 6 8 6 10.75 0.5 13.5 6"
                    style="
                      fill: none;
                      stroke: currentColor;
                      stroke-linecap: round;
                      stroke-linejoin: round;
                    "
                  ></polygon>
                  <circle
                    cx="3"
                    cy="11"
                    r="2.5"
                    style="
                      fill: none;
                      stroke: currentColor;
                      stroke-linecap: round;
                      stroke-linejoin: round;
                    "
                  ></circle>
                </g>
              </g>
            </svg>
          </template>
          <template #icon-images>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>
          </template>
          <template #icon-content>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z"
              />
            </svg>
          </template>

          <template v-slot="{ active }">
            <WebsiteData
              v-model="websiteData"
              :initialSource="initialSource"
              :class="skeClass"
              :website_type="website_type"
              key="data"
            />
            <CompanyDetails
              v-model="companyDetails"
              :initialSource="initialSource"
              :class="skeClass"
              :website_type="website_type"
              key="detils"
            />
            <WebAnalytics
              v-model="webAnalytics"
              :initialSource="sourceAndProperties"
              :class="skeClass"
              key="analytics"
            />

            <div class="padding">
              <ImagesHandlerGrid
                empty-state-title="This website doesn't have any images"
                :class="skeClass"
                :endpoint="endpoint"
                :options="websiteTypesOptions"
              />
            </div>
            <!-- <div key="content" class="mx-3 d-flex website-contents">
              <WebsiteContents
                :website-uid="websiteUid"
              />
            </div> -->
          </template>
        </SetupStepsSidebar>

        <template v-if="show" #bootstrap-modal-header-top>
          <div class="d-flex align-items-center left-header">
            <FormInput
              class="mb-0 domain-name"
              v-model="$v.domainname.$model"
              :vuelidate="$v"
              fieldName="domainname"
              :ske="true"
              id="domainname"
              placeholder="Domeinnaam"
            />

            <div class="row form--row">
              <div class="form-group--select">
                <input
                  type="radio"
                  value="online_store"
                  v-model="website_type"
                  class="form-checkbox"
                  id="website_type_online"
                />
                <label class="form-label" for="website_type_online">
                  Hoofdwebsite
                </label>
              </div>

              <div class="form-group--select">
                <input
                  type="radio"
                  value="wholesale"
                  v-model="website_type"
                  class="form-checkbox"
                  id="website_type_wholesale"
                />
                <label class="form-label" for="website_type_wholesale"
                  >Groothandel</label
                >
              </div>

              <div class="form-group--select">
                <input
                  type="radio"
                  value="physical_store"
                  v-model="website_type"
                  id="website_type_physical"
                  class="form-checkbox"
                />
                <label class="form-label" for="website_type_physical"
                  >Fysieke Winkel</label
                >
              </div>
            </div>
          </div>
        </template>
      </BootstrapModal>

      <portal
        v-if="show"
        to="bootstrap-modal-header-close-top"
        class="d-flex align-items-center"
      >
        <div class="d-flex align-items-center">
          <MultipleActionButton :options="options" @main-action="saveAndGoBack">
            Opslaan
          </MultipleActionButton>
        </div>
      </portal>

      <portal v-if="currentTab === 'content' && loadedWebsite" to="modals">
        <div class="faded-backgroud"></div>

        <BootstrapModal
          class="SimpleTextFieldModal"
          :removePadding="true"
          :disableButton="true"
          @close="closeModal"
        >
          <div>
            <MagentoEditor
              :domainName="domainname"
              :websiteUid="websiteUid"
              :wholesale="wholesale"
              :initialConfig="magento_config"
              @refetch-website="refetchConfig"
            />
          </div>

          <template #title> Website content </template>
        </BootstrapModal>
      </portal>
    </div>
  </div>
</template>

<script>
import BootstrapModal from "../../layout/Modals/BootstrapModal.vue";
import SetupStepsSidebar from "../../layout/SetupStepsSidebar/SetupStepsSidebar.vue";

import WebsiteData from "../../components/WebsiteForms/WebsiteData.vue";
import CompanyDetails from "../../components/WebsiteForms/CompanyDetails.vue";
import WebAnalytics from "../../components/WebsiteForms/WebAnalytics.vue";
import FormInput from "../../components/Inputs/FormInput.vue";
import ImagesHandlerGrid from "../../layout/ImagesHandlerGrid/ImagesHandlerGrid.vue";
import WebsiteContents from "./WebsiteTabs/WebsiteContents/WebsiteContents.vue";
import MagentoEditor from "../../components/Magento/MagentoEditor.vue";
import MultipleActionButton from "../../layout/MultipleActionButton.vue";
import FormCheckbox from "../../components/Inputs/FormCheckbox.vue";

import addedNewItemTableAlert from "../../mixins/addedNewItemTableAlert";

import { required, minLength } from "vuelidate/lib/validators";
import imageFileTypes from "src/mixins/imageFileTypes";

const url = url => {
  const match = url.match(
    /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/
  );
  if (url.includes("https://") || url.includes("http://")) return false;
  return match && match.length ? true : false;
};

export default {
  mixins: [addedNewItemTableAlert, imageFileTypes],
  components: {
    WebAnalytics,
    SetupStepsSidebar,
    WebsiteData,
    CompanyDetails,
    FormInput,
    ImagesHandlerGrid,
    WebsiteContents,
    FormCheckbox,
    MultipleActionButton,
    BootstrapModal,
    MagentoEditor
  },
  metaInfo: {
    title: "Nieuwe website"
  },
  validations: {
    domainname: {
      url,
      minLength: minLength(3)
    }
  },
  data() {
    return {
      show: false,
      loadedWebsite: false,
      domainname: "",
      currentTab: false,
      initialSource: null,
      websiteProperties: [],
      magento_config: null,
      oldTab: null,
      websiteData: {},
      companyDetails: {},
      webAnalytics: {},
      showSetup: true,
      website_type: null,
    };
  },
  mounted() {
    this.show = true;
  },
  async created() {
    if (this.websiteUid) {
      this.loadWebsite();
    } else this.loadedWebsite = true;
  },
  methods: {
    refetchConfig() {
      this.loadedWebsite = false;
      this.loadWebsite();
    },
    async loadWebsite() {
      const website = (await this.axios.get(`/api/websites/${this.websiteUid}`))
        .data;

      if(website.is_main == true)
        this.website_type = "online_store"
      else if(website.properties.physical_store == true)
        this.website_type = "physical_store"
      else if(website.properties.wholesale == true)
        this.website_type = "wholesale"

      this.magento_config = website.magento_config;
      this.initialSource = website;
      this.websiteProperties = website.properties || {};
      this.loadedWebsite = true;

      this.$v.domainname.$model = website.domainname;
    },

    closeModal() {
      this.$refs.steps.goToSection(this.oldTab || "website-data");
    },
    close() {
      this.$router.go(-1);
    },
    async saveWebsite() {
      this.$v.$touch();
      if (this.$refs.steps.hasError() || this.$v.$error) return false;

      const form = {
        ...this.websiteData,
        ...this.companyDetails,
        ...this.customerSupport,
        domainname: this.$v.domainname.$model,
        is_main: this.is_main,
        properties: this.websiteProperties,
      };

      const fieldsThatShouldNotBeInProperties = [
        "google_analytics_account_number",
        "google_adwords_conversion_id",
        "seo_headlines",
        "seo_descriptions",
        "keywords"
      ];
      const analytics = { ...this.webAnalytics };
      Object.keys(analytics).forEach(field => {
        if (fieldsThatShouldNotBeInProperties.includes(field)) {
          form[field] = analytics[field];
          delete analytics[field];
        }
      });
      form.properties = { ...form.properties, ...analytics };
      // console.log(fieldsThatShouldNotBeInProperties)
      // return console.log(form, analytics)

      // form.properties.wholesale = this.wholesale || false;

      if (!form.primary_color) form.primary_color = null;
      if (!form.secondary_color) form.secondary_color = null;
      if (!form.accent_color) form.accent_color = null;

      return await this.$handlePromise(async () => {
        let uid = false;

        if (!this.websiteUid) {
          const data = (await this.axios.post(`/api/websites`, form)).data;
          uid = data.uid;
          this.saveForShowingOnTableLater("website", data);
        } else {
          delete form.menu_items;
          (await this.axios.put(`/api/websites/${this.websiteUid}`, form)).data;
        }

        this.$success("Nieuw product succesvol toegevoegd!");
        return uid;
      });
    },
    async saveAndGoBack() {
      if (this.$refs.steps.goNext(false)) return;

      if (await this.saveWebsite()) this.$router.back();
    },
    async saveAndEdit() {
      const uid = await this.saveWebsite();
      if (uid) {
        this.$router.replace(`/admin/websites/edit/${uid}`);
        setTimeout(() => {
          this.$router.go();
        }, 100);
      }
    },
    async saveAndAddNew() {
      if ((await this.saveWebsite()) && !this.websiteUid) {
        this.initialSource = {};

        this.websiteData = {};
        this.companyDetails = {};
        this.webAnalytics = {};

        this.$v.domainname.$model = "";

        this.showSetup = false;
        this.$nextTick(() => (this.showSetup = true));
      }
    }
  },
  computed: {
    sourceAndProperties() {
      const source = this.initialSource;
      return source ? { ...source, ...source.properties } : {};
    },
    options() {
      const options = [
        {
          name: "Opslaan en teruggaan",
          action: this.saveAndGoBack
        },
        {
          name: "Opslaan en nieuwe toevoegen",
          action: this.saveAndAddNew
        }
      ];

      if (!this.websiteUid) {
        options.push({
          name: "Toevoegen en bewerken",
          action: this.saveAndEdit
        });
      }

      return options;
    },
    endpoint() {
      return `/api/websites/${this.websiteUid}/files`;
    },
    steps() {
      let steps = [
        {
          name: "Winkel gegevens",
          id: "website-data"
        },
        {
          name: "Bedrijfsgegevens",
          id: "company-details"
        },
        {
          name: "Analytics",
          id: "analytics"
        }
      ];

      if (this.websiteUid) {
        steps.push(
          {
            name: "Afbeeldingen",
            id: "images"
          },
          {
            name: "Inhoud",
            id: "content"
          }
        );
      }

      if (this.website_type == "physical_store")
        steps = steps.filter(s => {
          return s.name != "Inhoud";
        });

      return steps;
    },
    skeClass() {
      return !this.websiteUid || this.loadedWebsite ? "disable-ske" : "";
    },
    websiteUid() {
      return this.$route.params.id;
    }
  },
  watch: {
    currentTab(val, oldTab) {
      this.oldTab = oldTab;
    },
    website_type(value){
      if(value == "online_store"){
        this.is_main = true;
        this.websiteProperties.physical_store = false;
        this.websiteProperties.wholesale = false;
      }
      else if(value == "physical_store"){
        this.is_main = false;
        this.websiteProperties.physical_store = true;
        this.websiteProperties.wholesale = false;
      }
      else if(value == "wholesale"){
        this.is_main = false;
        this.websiteProperties.physical_store = false;
        this.websiteProperties.wholesale = true;
      }
    }
  }
};
</script>

<style scoped>
.form-label {
  font-weight: 600;
  margin-left: 8px;
  margin-bottom: unset;
}

.form-group--select {
  display: flex;
  align-items: center;
}

.row {
  margin: unset;
  margin-left: 8px;
}

.form--row .form-group--select:not(:first-child) {
  margin-left: 10px;
}

.ManageWebsites {
  align-items: start;
}

.fields-wrapper,
.modal-wrapper {
  flex-basis: 70%;
}

.fields-wrapper,
.modal-wrapper.images,
.fields-wrapper {
  flex-basis: 85%;
}

.fields-wrapper,
.modal-wrapper.content {
  flex-basis: 100%;
}

.website-contents {
  position: relative;
}

.modal {
  flex-grow: 1;
  width: 100%;
}

h1 {
  font-weight: 600;
  margin-top: 0px;
  margin-bottom: 13px;
  font-size: 28px;
}

.faded-backgroud {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  pointer-events: all;
}

.SimpleTextFieldModal {
  position: fixed;
  left: 0;
  top: 0;

  width: calc(100% - 40px);
  height: calc(100% - 80px);
  margin: 20px;
  margin-top: 40px !important;
}

@media (min-width: 900px) {
  .domain-name {
    width: 330px;
  }
}

@media (max-width: 1280px) {
  .fields-wrapper,
  .modal-wrapper {
    flex-basis: 100%;
  }
}

@media (max-width: 768px) {
  .left-header {
    flex-wrap: wrap;
  }

  .left-header > div:last-child {
    margin-top: 10px;
    transform: translateX(-10px);
  }

  .form--row {
    display: flex;
    flex-wrap: wrap;
  }

  .form--row .form-group--select:not(:first-child) {
    margin-left: unset;
  }

  .form-group--select {
    width: 100%;
    margin-top: 5px;
    padding-left: 10px;
  }

  .row {
    margin: unset;
  }
}
</style>
